import { jsxs as m, jsx as l } from "react/jsx-runtime";
import i from "react";
import { clsx as t } from "../../utils/clsx.js";
import '../../assets/Decorate.css';const _ = "_root_jt9ac_1", f = "_decorator_jt9ac_4", c = {
  root: _,
  decorator: f
}, u = i.forwardRef(function(o, a) {
  const {
    decorator: r,
    children: e,
    className: s
  } = o, d = t(c.root, s), n = t(c.decorator, o.decoratorClassName);
  return /* @__PURE__ */ m("div", { ref: a, className: d, children: [
    e,
    !!r && /* @__PURE__ */ l("div", { className: n, children: r })
  ] });
});
export {
  u as Decorate
};
